import { browserName, browserVersion } from 'react-device-detect'

// Chromium-based browsers are required for the main app because it relies on
// WebSerial for hardware connection (unavailable in Safari/Firefox).
export function isSupportedBrowser() {
    if (
        browserName === 'Chrome' ||
        browserName === 'Edge' ||
        browserName === 'Opera'
    ) {
        return parseInt(browserVersion) > 89
    }
    return false
}

// Routes that don't need WebSerial and must open in any browser, including
// Safari: the standalone Play viewers and the phone-camera page a scanned QR
// opens (the phone is a separate device with no hardware connection).
export const PLAY_VIEWER_PREFIXES = ['/playdynamex', '/playmex', '/mobilecamera']

export function isPlayViewerPath(pathname) {
    return PLAY_VIEWER_PREFIXES.some((prefix) => pathname.startsWith(prefix))
}
